import Vue from "vue";
let local
import {
  ValidationProvider,
  ValidationObserver,
  configure,
  extend,
  localize
} from "vee-validate";
import { required, email, min, numeric, regex } from "vee-validate/dist/rules";
localize('fr');
configure({ mode: "eager" });
extend("required", required);
extend("email", email);
extend("min", min);
extend("numeric", numeric);
extend("regex", regex);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);